var FormFeedback = (function ($) {

    var FormFeedback = function (options) {
        var that = this;

        that.selectors = {
            select_section_type: '.js-section-type',
            select_subject_type: '.js-subject-type',

            select_toggle_section_type: '.js-toggle-section-type',
            select_toggle_subject_type: '.js-toggle-subject-type',

            select_section_type_checked: '.js-section-type-checked',
            select_subject_type_checked: '.js-subject-type-checked',

            select_form_replacement_skeleton: '.js-form-replacement-skeleton',
            select_form_replacement_content: '.js-form-replacement-content'
        }        

        // DOM
        that.$wrapper = options["$wrapper"];

        that.$section_type = that.$wrapper.find(that.selectors.select_section_type);
        that.$section_type_checked = that.$wrapper.find(that.selectors.select_section_type_checked);

        that.$subject_type = that.$wrapper.find(that.selectors.select_subject_type);
        that.$subject_type_checked = that.$wrapper.find(that.selectors.select_subject_type_checked);

        // Load content
        that.$form_replacement_skeleton = that.$wrapper.find(that.selectors.select_form_replacement_skeleton);
        that.$form_replacement_content = that.$wrapper.find(that.selectors.select_form_replacement_content);

        // DYNAMIC VARS
        that.locales = options['locales'] || {};
        that.options_with_children = [];
        that.section_tree = options['section_tree'] || null;
        that.replacements = options['replacements'] || null;

        // INIT
        that.init(options);
    };

    var Self = FormFeedback;
    Self.className = 'FormFeedback';
    var Parent = FormAbstract;

    var def = FormAbstract.def;

    // "inherit"
    Self.prototype = Object.create(Parent.prototype);
    Self.prototype.constructor = Self;

    Self.prototype.init = function (options) {
        var that = this;

        options.onDoneSubmitCallback = function (response) {
            var unique_id = response?.data?.unique_id;

            that.$wrapper.find('.js-form-feedback').hide();
            that.$wrapper.find('.js-success-result').show();
            that.$wrapper.find('.js-unique-id').text(unique_id);
            $.sa.scrollToNode(that.$wrapper, 200, null);
        }

        options.onAlertSubmitCallback = that.onAlertSubmitCallback;

        Parent.prototype.init.call(that, options);

        that.initToggles();

        that.initInputMask();

        that.initCustomFields();
    };

    Self.prototype.initVars = function (options) {
        var that = this;
        options = options || {};

        that.selectors = {
            ...that.selectors,
            form: '.js-form-feedback',
            previous_action: '', //TODO: set this when other password restoration methods would be done
        };

        that.method = 'POST';

        that.url = def(options.url, '');
        that.has_success_screen = false;

        Parent.prototype.initVars.call(that, options);
        that.className = Self.className;
    };

    Self.prototype.initInputMask = function () {
        var that = this;

        UIInputMask.prototype.initPnrMask(that.$wrapper);
        UIInputMask.prototype.initPhoneMask(that.$wrapper);
        UIInputMask.prototype.initEmailValidate(that.$wrapper);
        UIInputMask.prototype.initDateMask(that.$wrapper);
    }

    Self.prototype.onAlertSubmitCallback = function (error) {
        var that = this,
            msg = error && error.message ? error.message : that.locales.error_message;

        $.uiModal({
            header_icons: '<div class="align-center"><i class="fab fa-sa-fill-mood-suprised2"></i><i class="fab fa-sa-fill-circle-x"></i></div>',
            header_title: '<div class="align-center">' + that.locales.error_title + '</div>',
            content: '<div class="align-center">' + msg + '</div>',
            button_align_center: true,
            button_confirm_text: that.locales.confirm_text,
        });
    }

    Self.prototype.__capitalizeFirstLetter = function (string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    };

    Self.prototype.getOptionsForSubjectTree = function (data = []) {
        var that = this;

        return data.map((el) => {
            return {...el, value: String(el.id), label: that.__capitalizeFirstLetter(el.name) };
        });
    }

    Self.prototype.initCustomFields = function () {
        var that = this;

        that.options_with_children = that.getOptionsForSubjectTree(that.section_tree, $.sa.current_locale_config.code);

        // Добавляем опции в селектор
        UISelect.prototype.__clearValue(that.$section_type);
        UISelect.prototype.makeOptionsFromArray(that.$section_type, that.options_with_children);
    }

    Self.prototype.initToggles = function () {
        var that = this;
        that.initSectionTypeToggle();
        that.initSubjectTypeToggle();
    }

    Self.prototype.initSectionTypeToggle = function () {
        var that = this;

        that.$wrapper.on('change', that.selectors.select_toggle_section_type, function (e) {
            var $toggle_select = $(e.target);
            var selected_section = $toggle_select.val();

            if (selected_section && $toggle_select.hasClass(that.selectors.select_toggle_section_type.substring(1))) {
                var find_replacement_section = that.replacements.find(function (el) {
                    return el.section === selected_section && !el.subject;
                });

                if (find_replacement_section && find_replacement_section.redirect_url) {
                    $.sa.content_router.load(find_replacement_section.redirect_url);
                    return;
                }

                // находим subject по theme
                var subjects_tree = that.options_with_children.find(function (el) {
                    return el.value === selected_section;
                });

                var subjects = that.getOptionsForSubjectTree(subjects_tree.children, $.sa.current_locale_config.code);

                // Добавляем опции в селектор
                UISelect.prototype.__clearValue(that.$subject_type);
                UISelect.prototype.makeOptionsFromArray(that.$subject_type, subjects);

                that.$section_type_checked.show();
                that.$subject_type_checked.hide();
                that.$form_replacement_skeleton.hide();
                that.$form_replacement_content.hide();
            }

        });
    }

    Self.prototype.__loadReplacementForm = function (form_id) {
        const that = this;

        that.$form_replacement_skeleton.show();

        $.ajax({
            url: '/form/replacement/',
            method: 'POST',
            async: true,
            data: {
                form_id: form_id,
            },
        })
            .done(function (response) {
                that.$form_replacement_content.html(response);
                that.$form_replacement_content.show();
            })
            .fail(function () {
                that.onAlertSubmitCallback();
            })
            .always(function () {
                that.$form_replacement_skeleton.hide();
            });
    }

    Self.prototype.initSubjectTypeToggle = function () {
        var that = this;

        that.$wrapper.on('change', that.selectors.select_toggle_subject_type, function (e) {
            var $toggle_select = $(e.target);
            var selected_section = $(that.selectors.select_toggle_section_type).val();
            var selected_subject = $toggle_select.val();

            if (selected_subject && $toggle_select.hasClass(that.selectors.select_toggle_subject_type.substring(1))) {
                var replacement_subject = that.replacements.find(function (el) {
                    return el.section === selected_section && el.subject === selected_subject;
                });

                that.$form_replacement_skeleton.hide();
                that.$form_replacement_content.hide();
                that.$subject_type_checked.hide();

                // Fallback - показываем дефолтное отображение формы для неподдерживаемых { selected_section, selected_subject }
                if (
                    !replacement_subject ||
                    (!replacement_subject.form_id && !replacement_subject.redirect_url)
                ) {
                    that.$subject_type_checked.show();
                    return;
                }

                // Переходим на страницу с формой с лоадером
                // Если ссылка не внешний ресурс, то просто переходим
                if (replacement_subject.redirect_url) {
                    $.sa.content_router.load(replacement_subject.redirect_url);
                    return;
                }

                // Подгружаем нужную форму ниже выбора
                if (replacement_subject.form_id) {
                    that.__loadReplacementForm(replacement_subject.form_id);
                }
            }
        });
    }

    return Self;
})(jQuery);